import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeBenefits = ({ role }) => {
  const getBenefits = () => {
    const benefits = {
      contractor: [
        {
          icon: 'Briefcase',
          title: 'Toegang tot Opdrachten',
          description: 'Direct toegang tot relevante opdrachten in uw vakgebied'
        },
        {
          icon: 'Star',
          title: 'Uitgelichte Profiel',
          description: '30 dagen gratis uitgelicht profiel voor nieuwe vakmensen'
        },
        {
          icon: 'TrendingUp',
          title: 'Verhoogde Zichtbaarheid',
          description: 'Uw profiel wordt getoond aan opdrachtgevers die zoeken naar uw vaardigheden'
        },
        {
          icon: 'MessageSquare',
          title: 'Direct Communicatie',
          description: 'Chat direct met opdrachtgevers over opdrachten'
        }
      ],
      client: [
        {
          icon: 'Users',
          title: 'Toegang tot Vakmensen',
          description: 'Direct toegang tot gekwalificeerde vakmensen in uw regio'
        },
        {
          icon: 'FileText',
          title: 'Gratis Opdracht Credits',
          description: '3 gratis opdracht plaatsingen voor nieuwe opdrachtgevers'
        },
        {
          icon: 'Shield',
          title: 'Veilige Betalingen',
          description: 'Beveiligde betalingsverwerking en contractbeheer'
        },
        {
          icon: 'BarChart',
          title: 'Project Tracking',
          description: 'Volg de voortgang van al uw projecten op één plek'
        }
      ],
      affiliate: [
        {
          icon: 'DollarSign',
          title: 'Commissie Verdienen',
          description: 'Verdien commissie op elke succesvolle verwijzing'
        },
        {
          icon: 'TrendingUp',
          title: 'Bonus Commissie',
          description: '10% extra commissie op uw eerste 5 verwijzingen'
        },
        {
          icon: 'Network',
          title: 'Netwerk Dashboard',
          description: 'Beheer al uw verwijzingen en commissies op één plek'
        },
        {
          icon: 'Award',
          title: 'Partner Voordelen',
          description: 'Exclusieve toegang tot partner events en training'
        }
      ]
    };

    return benefits?.[role] || [];
  };

  const benefits = getBenefits();

  const getWelcomeMessage = () => {
    const messages = {
      contractor: 'Welkom bij ons netwerk van professionele vakmensen!',
      client: 'Welkom! Begin direct met het vinden van de juiste vakmensen.',
      affiliate: 'Welkom bij ons partner programma!'
    };
    return messages?.[role] || 'Welkom bij het platform!';
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-primary/10 border border-primary/20 rounded-lg p-6 space-y-4">
      <div className="text-center space-y-2">
        <div className="text-3xl">🎁</div>
        <h2 className="text-xl font-semibold text-foreground">
          {getWelcomeMessage()}
        </h2>
        <p className="text-sm text-muted-foreground">
          Als nieuwe gebruiker ontvangt u deze voordelen:
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        {benefits?.map((benefit, index) => (
          <div
            key={index}
            className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                <Icon name={benefit?.icon} size={20} className="text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground">{benefit?.title}</h3>
                <p className="text-sm text-muted-foreground mt-1">{benefit?.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-card border border-border rounded-lg">
        <div className="flex items-start gap-2">
          <Icon name="Sparkles" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-foreground">
              <strong>Speciale Aanbieding:</strong> Voltooi uw profiel binnen 24 uur en ontvang extra voordelen!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBenefits;